import {useEffect,useState} from 'react';
import {PdfReadingPages} from './PdfReadingPages';
import './document-reading-surface.css';

/** Only authenticated object URLs from the existing document transport reach this surface. */
export function DocumentReadingSurface({url,fileName}:{url:string;fileName:string}){
 const [content,setContent]=useState<{url:string;pdf?:boolean;text?:string;error?:string}>();
 useEffect(()=>{
  let active=true;
  void (async()=>{
   try{
    if(!url.startsWith('blob:'))throw Error('The authenticated preview is unavailable. Reopen the document to retry.');
    const response=await fetch(url),blob=await response.blob(),type=blob.type.split(';')[0]?.toLowerCase();
    if(!response.ok)throw Error('The preview could not be read. Reopen the document to retry.');
    if(type==='application/pdf'){if(active)setContent({url,pdf:true});return;}
    if(!['text/plain','text/csv','text/html','application/xml','text/xml'].includes(type??''))throw Error('Use Download to open this file in its usual application.');
    let text=await blob.text();
    if(type==='text/html'){
     // Word extraction is already escaped by the API. Never mount supplied HTML or
     // open it as an active same-origin document: the template remains inert.
     const template=document.createElement('template');template.innerHTML=text;
     template.content.querySelectorAll('script,style,iframe,object,embed,link,meta').forEach(node=>node.remove());
     text=(template.content.querySelector('pre')??template.content).textContent??'';
    }
    if(active)setContent({url,text});
   }catch(error){if(active)setContent({url,error:error instanceof Error?error.message:'The preview is unavailable.'});}
  })();
  return()=>{active=false;};
 },[url]);
 if(content?.url!==url)return <p>Preparing reading view…</p>;
 if(content.error)return <p role="alert">{content.error}</p>;
 if(content.pdf)return <PdfReadingPages key={url} url={url} fileName={fileName}/>;
 return <pre className="document-reading-text" aria-label={`Preview of ${fileName}`}>{content.text||'No readable text was returned.'}</pre>;
}
